<template>
  <div class="login-dialog">
    <el-dialog title="登录" :visible.sync="dlFormVisible" custom-class="dialog-t" width="300px" :before-close="clearDl">
      
        <login :type="2" ref="login" @showlogin="showDialog" @showregist="showRegist"></login>
      
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="regist">确 定</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import login from '@/components/login/login'

export default {
  name: 'loginDialog',
  data () {
    return {
      dlFormVisible: false
    }
  },
  methods: {
    showDialog(state) {
      this.dlFormVisible = state
    },
    showRegist() {
      this.$emit('showregist')
    },
    clearDl(done) {
      done()
      // this.$refs.login.clearDl()
    }
  },
  components: {
    login
  }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// loginDialog.vue?ae17d0b8